/**
 * Loại văn bản, khớp `DOCUMENT_TYPES` của document-service bản native (`summarization.py`). Là **dữ liệu
 * nghiệp vụ** gửi nguyên văn lên backend (`default_doc_type`, `doc_type`), backend so khớp đúng chuỗi,
 * nên không dịch ở chế độ tiếng Anh (ADR-UI-0010 mục 5).
 */
export const LOAI_VAN_BAN: readonly string[] = [
  'Công văn',
  'Báo cáo',
  'Kế hoạch',
  'Thông báo',
  'Quyết định',
  'Tờ trình',
  'Biên bản',
  'Hợp đồng',
  'Khác',
];
